var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorlogoNobackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 50,
    viewBox: "0 0 3187.5 1081.0682849819163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(9.375) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1936"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient1941"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1942",
    stopColor: "#2d388a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1943",
    stopColor: "#00aeef",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient1944"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1945",
    stopColor: "#2d388a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1946",
    stopColor: "#00aeef",
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1937",
    featureKey: "symbolFeature-0",
    transform: "matrix(1.147380315186437,0,0,1.147380315186437,-7.3688953943367,-9.711616000156868)",
    fill: "url(#SvgjsLinearGradient1941)"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.622,23.06c8.215-5.156,19.509-9.774,25.012-7.465   c20.317,8.639,7.215,32.554,0.731,42.347c5.099,0.693,26.955,8.87,21.279,22.164c-6.041,14.43-37.556,14.872-49.273,3.155   c11.332,6.349,40.115,3.559,34.478-11.929c-1.539-4.021-8.581-7.292-15.45-9.293c8.235-13.102,13.833-28.379,2.155-33.804   c-17.22-8.004-46.426,25.512-35.382,45.56C-9.48,48.649,4.526-21.768,45.622,23.06L45.622,23.06z M29.172,73.796   C-5.267,38.106,21.053,5.533,39.87,28.909C25.825,43.801,21.707,64.137,29.172,73.796L29.172,73.796z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.238,73.907c-6.07-13.596,13.838-32.533,21.284-30.671    c3.723,0.971,9.792,5.422,0,23.631c5.098,0.243,9.63,4.208,9.226,7.688c-0.728,5.584-10.359,9.873-16.266,8.74    c11.896,4.451,30.105-4.127,24.925-12.786c-2.59-4.289-7.688-5.503-13.272-5.827c5.179-7.041,12.786-25.654-0.081-30.105    C39.273,29.235,22.198,60.311,29.238,73.907L29.238,73.907z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.238,73.907c-21.85-22.983-9.307-51.065,5.503-38.359    c-1.133,1.376-2.752,4.127-3.642,5.665C16.775,42.345,21.226,65.005,29.238,73.907L29.238,73.907z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1938",
    featureKey: "nameFeature-0",
    transform: "matrix(1.348478476113972,0,0,1.348478476113972,115.49783708669719,9.396026457634946)",
    fill: "url(#SvgjsLinearGradient1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.899 28.789 c-0.039766 2.7314 -0.0003125 8.8604 0.00046876 8.9216 l0.01543 2.3398 l-15.796 0 c-4.7468 0 -8.7176 -1.0623 -11.483 -3.0715 c-2.7712 -2.0134 -4.2972 -4.934 -4.2972 -8.224 c0 -2.7283 1.0293 -5.1928 2.9771 -7.126 c2.7887 -2.7683 7.2208 -4.2116 12.82 -4.1692 c3.4152 0.025117 13.333 0.00027344 13.433 0 l2.3244 -0.0060156 l0.011758 4.6492 l-2.3244 0.0060156 c-0.1002 0.00027344 -10.041 0.025391 -13.479 0 c-4.2752 -0.03375 -7.648 0.9702 -9.5112 2.8196 c-1.0641 1.0562 -1.6035 2.3435 -1.6035 3.8266 c0 4.0992 4.2652 6.646 11.132 6.646 l11.12 0 c-0.0049608 -1.2739 -0.0086328 -2.879 -0.0049608 -4.3216 l-8.9542 0 l0 -4.6491 l13.654 0 z M46.354 35.238 l27.18 0 l0 4.6954 l-31.875 0 l0 -22.815 l4.6954 0 l0 18.119 z M96.59100000000001 16.021 l18.353 24.38 l-5.9015 0 l-5.132 -6.7948 l-14.639 0 l-5.0572 6.7948 l-5.8354 0 z M92.792 28.911 l7.5966 0 l-3.7984 -5.0644 z M135.716 28.125999999999998 l15.938 -10.625 l0 22.5 l-4.6954 0 l0 -13.726 l-11.242 7.4944 l-11.242 -7.4944 l0 13.726 l-4.6954 0 l0 -22.5 z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorlogoNobackground);
export default __webpack_public_path__ + "static/media/Color logo - no background.59f14250dd7d3a249a9baf1668b386e9.svg";
export { ForwardRef as ReactComponent };